import { createRouter as _createRouter, createWebHistory } from 'vue-router';

import { createRoutes } from '@/router/routes';
import { beforeEachRoute, beforeResolveRoute, onAfterEach } from '@/router/utils/router.util';
import { handleError } from '@/shared/utils/error.util';

export const createRouter = (auth, store) => {
    const routes = createRoutes(auth, store);
    const router = _createRouter({
        history: createWebHistory(),
        scrollBehavior: (_, __, savedPosition) => {
            if (savedPosition) {
                return savedPosition;
            }

            return { top: 0, left: 0 };
        },
        routes,
    });

    router.beforeEach(beforeEachRoute);
    router.beforeResolve(beforeResolveRoute);
    router.afterEach(onAfterEach);
    router.onError(handleError);

    return router;
};
